import React, { useMemo } from "react";
import { FiCheck, FiCopy, FiArrowLeft } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { toast } from "react-hot-toast";

export default function GiftSuccess() {
  const params = new URLSearchParams(window.location.search);

  const coachId = params.get("coach");
  const amount = params.get("amount");
  const coachName = params.get("name") || "your coach";
  const note = params.get("note") || "";

  const amountText = useMemo(() => {
    const n = Number(amount);
    if (Number.isFinite(n)) {
      return `AED ${n.toLocaleString("en-AE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    return "your gift";
  }, [amount]);

  const coachUrl = coachId ? `/coach/${coachId}?tab=thanks` : "/";
  const fullCoachUrl = `${window.location.origin}${coachUrl}`;

  const handleWhatsAppShare = () => {
    const text = `I just sent a Thanks gift (${amountText}) to ${coachName} on PTfinderNow 🎁

Check their profile here:
${fullCoachUrl}`;

    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(fullCoachUrl);
    toast.success("Link copied!");
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white border rounded-2xl p-6 shadow-sm">
        
        {/* Header */}
        <div className="flex items-center gap-3 text-emerald-700">
          <div className="h-10 w-10 rounded-full bg-emerald-100 flex items-center justify-center">
            <FiCheck />
          </div>
          <h1 className="text-xl font-semibold">Payment Successful</h1>
        </div>

        {/* Main text */}
        <p className="mt-4 text-gray-700 leading-relaxed">
          Thank you! We’ve received <strong>{amountText}</strong>.  
          Your support to <strong>{coachName}</strong> means a lot 💛
        </p>

        {/* Note */}
        {note && (
          <p className="mt-3 text-gray-600">
            <span className="font-medium">Your message: </span>
            <span className="italic">{note}</span>
          </p>
        )}

        {/* Buttons */}
        <div className="mt-6 flex flex-wrap gap-2">
          <a
            href={coachUrl}
            className="px-4 py-2 rounded-lg bg-gray-900 text-white inline-flex items-center gap-2"
          >
            <FiArrowLeft /> Back to coach profile
          </a>

          <button
            type="button"
            onClick={handleWhatsAppShare}
            className="px-4 py-2 rounded-lg bg-green-500 text-white inline-flex items-center gap-2 hover:bg-green-600"
          >
            <FaWhatsapp />
            Share on WhatsApp
          </button>

          <button
            type="button"
            onClick={handleCopy}
            className="px-4 py-2 rounded-lg border inline-flex items-center gap-2"
          >
            <FiCopy /> Copy link
          </button>
        </div>

        {/* Tip */}
        <p className="mt-6 text-xs text-gray-500">
          If the gift doesn’t appear instantly in the coach dashboard, wait a few
          seconds and press “Refresh”.
        </p>
      </div>
    </div>
  );
}
